import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const selectedVisualizationAxesAtom = atomWithReset<string[]>([]);

export const traceAtom = atomWithReset<string[]>([]);

export const swingPlanesAtom = atomWithReset<string[]>([]);

export const pathsAtom = atomWithReset<string[]>([]);

export const axisFocusIdAtom = atom<string | undefined>();

export const selectedAxisFocusIdAtom = atom((get) => {
    const axisFocusId = get(axisFocusIdAtom);
    const selectedVisualizationAxes = get(selectedVisualizationAxesAtom);
    if (axisFocusId && selectedVisualizationAxes.includes(axisFocusId)) {
        return axisFocusId;
    }
    return undefined;
});

export const hasVisualizationsAtom = atom(
    (get) =>
        !!get(selectedAxisFocusIdAtom) ||
        !!get(traceAtom).length ||
        !!get(swingPlanesAtom).length ||
        !!get(pathsAtom).length,
);

export const showVisualizationsAtom = atom(false);
